
import { mapState } from "vuex";

export default {
  name: "Auth2FALayout",
  components: {},
  middleware: ["notAuthenticated"],

  computed: {
    ...mapState("application", ["taggedVersion"]),
  },
};
